export const MAPPED = "mapped"
export const UNMAPPED = "unmapped"

export const CONFIGURATION_FIELD_TYPES = {
  SELECT: "select",
  DATE: "date",
}

export const SYNC_STATUSES = {
  DESTROYED: "destroyed",
  EXCLUDED: "excluded",
  FAILED: "failed",
  FROZEN: "frozen",
  PENDING: "pending",
  SUCCESS: "success",
}

// Order the marina cares about: the statuses that need attention come first.
export const SYNC_STATUS_FILTER_OPTIONS = [
  SYNC_STATUSES.FAILED,
  SYNC_STATUSES.EXCLUDED,
  SYNC_STATUSES.FROZEN,
  SYNC_STATUSES.PENDING,
  SYNC_STATUSES.SUCCESS,
  SYNC_STATUSES.DESTROYED,
]

// The marina-facing codes SyncError::CODES assigns; the server answers 400 for any other.
export const SYNC_ERROR_CODE_FILTER_OPTIONS = [
  "customer-001",
  "customer-002",
  "item-001",
  "item-002",
  "item-003",
  "sync-001",
  "sync-002",
  "sync-003",
  "sync-004",
  "sync-005",
  "sync-006",
  "sync-007",
  "sync-008",
  "sync-009",
  "sync-010",
]

export const DOCUMENT_TYPE_OPTIONS = [
  { value: "invoice", label: "Invoice" },
  { value: "credit_note", label: "Credit note" },
  { value: "payment", label: "Payment" },
  { value: "refund", label: "Refund" },
]

export const documentTypeLabel = (documentType) =>
  DOCUMENT_TYPE_OPTIONS.find((option) => option.value === documentType)
    ?.label || documentType
